var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prop',{attrs:{"name":_vm.propName}},[_c('router-link',{attrs:{"to":{name: this.type + 'Detail', params: {id: this.id}}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }